import { render, staticRenderFns } from "./VisualRecognitionDetailView.vue?vue&type=template&id=7659a58d&"
import script from "./VisualRecognitionDetailView.vue?vue&type=script&lang=js&"
export * from "./VisualRecognitionDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports